export const GA_MEASUREMENT_ID = "G-366C30KGQ3";
const PRODUCTION_HOSTS = new Set(["alphaappraisals.ca", "www.alphaappraisals.ca"]);

export function isPrivatePath(pathname) {
  return /^\/(admin|invoice)(\/|$)/.test(pathname);
}

export function canTrack() {
  return typeof window !== "undefined" &&
    PRODUCTION_HOSTS.has(window.location.hostname) &&
    !isPrivatePath(window.location.pathname);
}

export function initializeGoogleTracking() {
  if (!canTrack()) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };
  if (window.__alphaGoogleTrackingConfigured) return;
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID);
  ["AW-10995985296", "AW-11144453197"].forEach((id) => window.gtag("config", id));
  window.__alphaGoogleTrackingConfigured = true;
}

// A document navigation discards Google's automatic listeners when crossing
// into internal tools. Install before loading gtag so history changes cannot
// send an internal-page event from the previous public document.
export function installTrackingBoundary() {
  const privateDocument = isPrivatePath(window.location.pathname);
  const originals = {};
  for (const method of ["pushState", "replaceState"]) {
    originals[method] = window.history[method];
    window.history[method] = function (state, unused, url) {
      if (url != null) {
        const destination = new URL(url, window.location.href);
        if (destination.origin === window.location.origin &&
            isPrivatePath(destination.pathname) !== privateDocument) {
          window.location[method === "replaceState" ? "replace" : "assign"](destination.href);
          return;
        }
      }
      return originals[method].apply(this, arguments);
    };
  }
  // Read at send time, including back/forward transitions before React renders.
  Object.defineProperty(window, `ga-disable-${GA_MEASUREMENT_ID}`, {
    configurable: true,
    get: () => !canTrack(),
  });
  const onPopState = () => {
    if (isPrivatePath(window.location.pathname) !== privateDocument) window.location.reload();
  };
  window.addEventListener("popstate", onPopState);
  return () => {
    for (const method of Object.keys(originals)) window.history[method] = originals[method];
    window.removeEventListener("popstate", onPopState);
  };
}
